import React from "react";
import { useState, useEffect } from "react";
import * as urls from "../../../src/urls"; ///utils/urls
import "./responsiveHeader.css";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";

///Image
import YoindiLogoSmall from "./images/youindiLogosmall.png";
// import './Header.css'; // Import your CSS file for styling if needed

const HeaderDesk = ({navVisible, setNavVisible}) => {
  console.log("-----",navVisible);
  let domain = window.location.host.split(".")[0];
  if (window.location.host.includes("localhost")) {
    domain = "yoindi";
  }
  console.log("domain name", domain);

  const [orgLogoData, setOrgLogoData] = useState(null);
  console.log("orgLogoData", orgLogoData);

  ////customersLogo Apis////
  useEffect(() => {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}${urls.CustomersLogo}`;
    const headers = {
      "Content-Type": "application/json",
      domain_name: domain,
    };

    fetch(apiUrl, {
      method: "GET",
      headers: headers,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("org logo data", data?.data?.documents);
        setOrgLogoData(data?.data?.documents);
      })
      .catch((error) => {
        const { response } = error;
        console.log("org_error=>", { response, error });
        console.error(error);

        const { data } = response;

        props.updateAlertMsg({
          message:
            (data && data.message) ||
            "Something went wrong with organization Logo",
          messageType: "error",
        });
      });
  }, []);
  ////

  const handleDrawerClose = {};

  return (
    <header>
      <div className="resheader">
        <span className="menu">
          <IconButton
            color="#2E3092"
            onClick={() => setNavVisible(!navVisible)}
            sx={{
              marginRight: 0,
              //   ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
        </span>
        <img
          className="YoindiLogo"
          // src={orgLogoData}
          src={`${process.env.REACT_APP_DOCUMENTS_BASE_URL}${orgLogoData}`}
        />
      </div>
    </header>
  );
};

export default HeaderDesk;
